// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchFormTabs_wrapper__02rBg"};